
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/multimodal",
      function () {
        return require("private-next-pages/multimodal.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/multimodal"])
      });
    }
  